module.exports = __webpack_public_path__ + "static/media/icone-impressora-branco.22dedce3.svg";